import React from 'react'

import { Form, Input, InputNumber, Select } from 'antd'
import PropTypes from 'prop-types'
import './PracticeNumbers.css'

const NumberForm = ({
  form,
  index,
  number,
  status,
  restrictions,
  setAudioFile,
  setImageFile,
  audioFileRef,
  imageFileRef
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <div style={{ marginBottom: '3%' }}>
        <>Аудио</>
        <input
          type="file"
          accept="audio/*"
          ref={audioFileRef}
          onChange={event => {
            setAudioFile(event.target.files[0])
          }}
        />
        <>Изображение</>
        <input
          type="file"
          accept="image/*"
          ref={imageFileRef}
          onChange={event => setImageFile(event.target.files[0])}
        />
      </div>
      <FormItem
        key="index"
        label="Очередность Цифры"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите Очередность Документа`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность" />
      </FormItem>

      <FormItem
        key="restrictions"
        label="План"
        name="restrictions"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите план`
          }
        ]}
        initialValue={restrictions}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="basic" value="basic">
            Basic
          </Select.Option>
          <Select.Option key="premium" value="premium">
            Premium
          </Select.Option>
        </Select>
      </FormItem>

      <FormItem
        key="status"
        label="Статус Цифры"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="active" value="active">
            Автивный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="number"
        label="Цифра"
        name="number"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите Букву`
          }
        ]}
        initialValue={number}
      >
        <Input placeholder="Цифра" maxLength={1} />
      </FormItem>
    </Form>
  )
}

NumberForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired
}

NumberForm.defaultProps = {
  number: '',
  status: 'active'
}

export default NumberForm
